module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAloAAAAgCAMAAAD9oyZWAAAAHlBMVEVHcEz/dl/+cV7+dl/+eV39bF39a2H9amD9bGD+bWBZQYknAAAACnRSTlMAI1g8EHb+4MmnyUl91wAAAOlJREFUeNrt2dEKwyAMhWFjYtT3f+EZ68YudjEGQh3/h9DLFnqIJiYAAAAAAAAAAHAE6Qlns27phqQ62TqbNW92y2Q52To9We7NbpisptStw5NVtXqz+yXL2BNPT5asH7mXJQtiMqnokjU/lVyW9UHUrbOTFc/qrSy55CfNuojKZGLTD68yk0HDCtLUS5/aVIMHSSG7l4QDdXdNQT3U0EK/lP6eNh0k/JatIGNd9CXr56pFl/gPVUuial3yWBf9WLXEhmSctfD1WYsOEXs6ROZa2DPXYhqPPdN47hCx6Q4RAAAAAAAAALDJA0xcB89YQ1dcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/rule-title-bg.png
// module id = BmdD
// module chunks = 216